// import React, { useState, useEffect } from "react";
// import { NavLink, useLocation } from "react-router-dom";
// import { RiArrowRightSLine } from "react-icons/ri";
// import logo from "../../../assets/logo/MH-icon.png";
// import whiteLogo from "../../../assets/logo/logo-white.png";
// import { sidebarSections } from "../../../utils/menuData";

// const Sidebar = ({ isSidebarOpen, setIsSidebarOpen, isAdmin, isSuperAdmin, isPathologist, isPharmacist, isNicuInCharge, isDoctor, isHospitalManager, isPatient }) => {
//   const [expandedMenu, setExpandedMenu] = useState({
//     main: null,
//     pharmacy: null,
//     pathology: null,
//     cms: null,
//     settings: null,
//     contact: null,
//     others: null,
//   });
//   const location = useLocation();

//   const findActiveMenu = () => {
//     let activeSectionKey = null;
//     let activeMenuIndex = null;

//     for (const section of sidebarSections) {
//       for (let i = 0; i < section.menus.length; i++) {
//         const menuItem = section.menus[i];

//         if (menuItem.link === location.pathname) {
//           activeSectionKey = section.sectionKey;
//           activeMenuIndex = i;
//           break;
//         }

//         if (menuItem.submenus) {
//           for (const subMenuItem of menuItem.submenus) {
//             if (subMenuItem.link === location.pathname) {
//               activeSectionKey = section.sectionKey;
//               activeMenuIndex = i;
//               break;
//             }
//           }
//         }

//         if (activeSectionKey && activeMenuIndex !== null) break;
//       }
//       if (activeSectionKey && activeMenuIndex !== null) break;
//     }

//     return { activeSectionKey, activeMenuIndex };
//   };

//   useEffect(() => {
//     const { activeSectionKey, activeMenuIndex } = findActiveMenu();

//     if (activeSectionKey && activeMenuIndex !== null) {
//       setExpandedMenu({
//         main: null,
//         pharmacy: null,
//         pathology: null,
//         cms: null,
//         settings: null,
//         contact: null,
//         others: null,
//         [activeSectionKey]: activeMenuIndex,
//       });
//       setIsSidebarOpen(true);
//     }
//   }, [location.pathname, setIsSidebarOpen]);

//   const toggleSubMenu = (index, sectionKey) => {
//     setExpandedMenu((prev) => {
//       const isAlreadyOpen = prev[sectionKey] === index;

//       return {
//         main: null,
//         pharmacy: null,
//         pathology: null,
//         cms: null,
//         settings: null,
//         contact: null,
//         others: null,
//         [sectionKey]: isAlreadyOpen ? null : index,
//       };
//     });
//   };

//   return (
//     <div
//       className={`h-full bg-M-heading-color text-white min-h-screen transition-all duration-300 hover:w-72 group ${
//         isSidebarOpen ? "w-72" : "w-16"
//       }`}
//     >
//       <div className="relative">
//         <div
//           className={`gap-2 py-[17px] border-b border-M-section-bg/10 flex ${
//             isSidebarOpen
//               ? "px-6"
//               : "px-2 group-hover:px-6 justify-center group-hover:justify-between"
//           }`}
//         >
//           <NavLink to="/" title="User Profile">
//             <div className="flex items-center justify-between">
//               <div className="group mx-auto w-full flex items-center gap-3">
//                 <img
//                   src={whiteLogo}
//                   alt="White Logo"
//                   title="White Logo"
//                   className={`duration-0 max-w-48 ${
//                     isSidebarOpen ? "w-48" : "hidden group-hover:block w-48"
//                   }`}
//                 />
//                 <img
//                   src={logo}
//                   alt="Logo"
//                   title="Logo"
//                   className={`duration-0 rounded-full shrink-0 mx-auto ${
//                     isSidebarOpen ? "hidden" : "w-9 group-hover:hidden"
//                   }`}
//                 />
//               </div>
//             </div>
//           </NavLink>
//         </div>

//         <span
//           onClick={() => setIsSidebarOpen(!isSidebarOpen)}
//           className={`size-5 border-2 border-white rounded-full absolute right-3 top-1/2 -translate-y-1/2 hidden ${
//             isSidebarOpen
//               ? "lg:flex items-center justify-center"
//               : "hidden group-hover:lg:flex"
//           }`}
//         >
//           <span
//             className={`size-2 bg-white rounded-full ${
//               isSidebarOpen ? "block" : "hidden"
//             }`}
//           ></span>
//         </span>
//       </div>

//       <div
//         className={`menu-bar hide-scrollbar ${
//           isSidebarOpen ? "px-4" : "px-2 group-hover:px-4"
//         } h-[calc(100vh-80px)] overflow-y-auto`}
//       >
//         {sidebarSections.map((section, sectionIndex) => {
//           const visibleMenus = section.menus.filter((menuItem) => {
//             if (menuItem.isPatient === true) {
//         return isPatient; 
//     }
//             if (isAdmin || isSuperAdmin) return true;
//             // if (menuItem.isAdmin && isAdmin) return true;
//             if (menuItem.isSuperAdmin && isSuperAdmin) return true;
//             if (menuItem.isPharmacist === true && isPharmacist) return true;
//             if (menuItem.isPathologist === true && isPathologist) return true;
//             if (menuItem.isNicuInCharge === true && isNicuInCharge) return true;
//             if (menuItem.isDoctor === true && isDoctor) return true;
//             if (menuItem.isHospitalManager === true && isHospitalManager) return true;
//             // if (menuItem.isPatient === true && isPatient) return true;
//     //         if (menuItem.isPatient === true) {
//     //     return isPatient; 
//     // }
//             if (menuItem.isNicuInCharge === true && isNicuInCharge) return true;

//             if ((menuItem.isAdmin === true || menuItem.isSuperAdmin === true) && !(isAdmin || isSuperAdmin)) {
//               return false;
//             }
//             if (menuItem.isPharmacist === true && !isPharmacist) {
//               return false;
//             }
//             if (menuItem.isPathologist === true && !isPathologist)  {
//               return false;
//             }
//             if (menuItem.isNicuInCharge === true && !isNicuInCharge) {
//               return false;
//             }
//             if (menuItem.isDoctor === true && !isDoctor) {
//               return false;
//             }
//             if (menuItem.isHospitalManager === true && !isHospitalManager) {
//               return false;
//             }
//             if (menuItem.isPatient === true && !isPatient) return false;

//             if (menuItem.isSubmenu) {
//               const visibleSubmenus = menuItem.submenus?.filter((subMenuItem) => {
//                 if (isAdmin || isSuperAdmin) return true;
//                 if (subMenuItem.isPharmacist === true && isPharmacist) return true;
//                 if (subMenuItem.isPathologist === true && isPathologist) return true;
//                 if (subMenuItem.isNicuInCharge === true && isNicuInCharge) return true;
//                 if (subMenuItem.isDoctor === true && isDoctor) return true;
//                 if (subMenuItem.isHospitalManager === true && isHospitalManager) return true;
//                 if (subMenuItem.isPatient === true && isPatient) return true;

//                 if (
//                   (subMenuItem.isAdmin === true || subMenuItem.isSuperAdmin === true) &&
//                   !(isAdmin || isSuperAdmin)
//                 ) return false;
//                 if (subMenuItem.isPharmacist === true && !isPharmacist) return false;
//                 if (subMenuItem.isPathologist === true && !isPathologist) return false;
//                 if (subMenuItem.isNicuInCharge === true && !isNicuInCharge) return false;
//                 if (subMenuItem.isDoctor === true && !isDoctor) return false;
//                 if (subMenuItem.isHospitalManager === true && !isHospitalManager) return false;
//                 if (subMenuItem.isPatient === true && !isPatient) return false;
//                 return true;
//               });
//               return visibleSubmenus?.length > 0;
//             }

//             return true;
//           });

//           if (visibleMenus.length === 0) {
//             return null;
//           }

//           return (
//             <div key={sectionIndex}>
//               <h4
//                 className={`pb-2 mt-4 border-b border-M-text-color/30 text-[#97aac1] font-semibold uppercase text-xs ml-2 tracking-wide ${
//                   isSidebarOpen
//                     ? ""
//                     : "text-center hidden group-hover:block group-hover:text-left text-nowrap"
//                 }`}
//               >
//                 {section.title}
//               </h4>
//               <ul className={`flex flex-col font-inter mt-1`}>
//                 {section.menus.map((menuItem, menuIndex) => {
//                   if (
//                     (isAdmin || isSuperAdmin) ||
//                     (menuItem.isPharmacist === true && isPharmacist) ||
//                     (menuItem.isPathologist === true && isPathologist) ||
//                     (menuItem.isNicuInCharge === true && isNicuInCharge) ||
//                     (menuItem.isDoctor === true && isDoctor) ||
//                     (menuItem.isHospitalManager === true && isHospitalManager) ||
//                     (menuItem.isPatient === true && isPatient)
//                   ) {
//                     if (menuItem.isSubmenu && !menuItem.submenus?.some(() => true)) {
//                       return null;
//                     }
//                   } else {
//                     if (
//                       ((menuItem.isAdmin === true || menuItem.isSuperAdmin === true) && !(isAdmin || isSuperAdmin)) ||
//                       (menuItem.isPharmacist === true && !isPharmacist) ||
//                       (menuItem.isPathologist === true && !isPathologist) ||
//                       (menuItem.isNicuInCharge === true && !isNicuInCharge) ||
//                       (menuItem.isDoctor === true && !isDoctor) ||
//                       (menuItem.isHospitalManager === true && !isHospitalManager)
//                     ) {
//                       return null;
//                     }

//                     if (menuItem.isSubmenu) {
//                       const visibleSubmenus = menuItem.submenus?.filter((subMenuItem) => {
//                         if (isAdmin || isSuperAdmin) return true;
//                         if (subMenuItem.isPharmacist === true && isPharmacist) return true;
//                         if (subMenuItem.isPathologist === true && isPathologist) return true;
//                         if (subMenuItem.isNicuInCharge === true && isNicuInCharge) return true;
//                         if (subMenuItem.isDoctor === true && isDoctor) return true;
//                         if (subMenuItem.isHospitalManager === true && isHospitalManager) return true;
//                         if (subMenuItem.isPatient === true && isPatient) return true;

//                         if (
//                           (subMenuItem.isAdmin === true || subMenuItem.isSuperAdmin === true) &&
//                           !(isAdmin || isSuperAdmin)
//                         ) return false;
//                         if (subMenuItem.isPharmacist === true && !isPharmacist) return false;
//                         if (subMenuItem.isPathologist === true && !isPathologist) return false;
//                         if (subMenuItem.isNicuInCharge === true && !isNicuInCharge) return false;
//                         if (subMenuItem.isDoctor === true && !isDoctor) return false;
//                         if (subMenuItem.isHospitalManager === true && !isHospitalManager) return false;
//                         if (subMenuItem.isPatient === true && !isPatient) return false;
//                         return true;
//                       });
//                       if (visibleSubmenus?.length === 0) return null;
//                     }
//                   }

//                   return (
//                     <React.Fragment key={`${section.sectionKey}-${menuIndex}`}>
//                       <li>
//                         <div
//                           className="mt-1"
//                           onClick={() =>
//                             menuItem.isSubmenu &&
//                             toggleSubMenu(menuIndex, section.sectionKey)
//                           }
//                         >
//                           {menuItem.isSubmenu ? (
//                             <div
//                               className={`flex items-center gap-2 cursor-pointer hover:bg-[rgba(255,255,255,0.16)] w-full py-2 px-2 rounded-md ${
//                                 isSidebarOpen
//                                   ? "justify-between"
//                                   : "justify-center group-hover:justify-between"
//                               }`}
//                             >
//                               <span className="flex items-center gap-2 text-sm text-[#e2eeff]">
//                                 <menuItem.icon />
//                                 <span
//                                   className={`${
//                                     isSidebarOpen
//                                       ? ""
//                                       : "hidden group-hover:block text-nowrap"
//                                   } `}
//                                 >
//                                   {menuItem.name}
//                                 </span>
//                               </span>

//                               {menuItem.isSubmenu && (
//                                 <RiArrowRightSLine
//                                   className={`transform transition-transform duration-300 ${
//                                     expandedMenu[section.sectionKey] === menuIndex
//                                       ? "rotate-90"
//                                       : ""
//                                   } ${
//                                     isSidebarOpen
//                                       ? ""
//                                       : "hidden group-hover:block"
//                                   }`}
//                                 />
//                               )}
//                             </div>
//                           ) : (
//                             <div
//                               className={`flex items-center gap-2 cursor-pointer ${
//                                 isSidebarOpen
//                                   ? "justify-between"
//                                   : "justify-center"
//                               }`}
//                             >
//                               <NavLink
//                                 to={menuItem.link}
//                                 className={({ isActive }) =>
//                                   `flex gap-2 items-center text-sm text-[#e2eeff] hover:bg-[rgba(255,255,255,0.16)] py-2 px-2 rounded-md ${
//                                     isActive
//                                       ? "bg-[rgba(255,255,255,0.16)] text-white"
//                                       : ""
//                                   } ${
//                                     isSidebarOpen
//                                       ? "w-full"
//                                       : "w-auto group-hover:w-full"
//                                   }`
//                                 }
//                               >
//                                 <menuItem.icon />
//                                 <span
//                                   className={`${
//                                     isSidebarOpen
//                                       ? ""
//                                       : "hidden group-hover:block text-nowrap"
//                                   } `}
//                                 >
//                                   {menuItem.name}
//                                 </span>
//                               </NavLink>
//                             </div>
//                           )}
//                         </div>
//                       </li>

//                       <ul
//                         className={`transition-all duration-500 overflow-hidden text-sm text-gray-400 ${
//                           expandedMenu[section.sectionKey] === menuIndex
//                             ? "max-h-96 opacity-100"
//                             : "max-h-0 opacity-0"
//                         } ${isSidebarOpen ? "" : "hidden group-hover:block"}`}
//                       >
//                         {menuItem.submenus?.map((subMenuItem, subIndex) => {
//                           if (
//                             !(
//                               (isAdmin || isSuperAdmin) ||
//                               (subMenuItem.isPharmacist === true && isPharmacist) ||
//                               (subMenuItem.isPathologist === true && isPathologist) ||
//                               (subMenuItem.isNicuInCharge === true && isNicuInCharge) ||
//                               (subMenuItem.isDoctor === true && isDoctor) ||
//                               (subMenuItem.isHospitalManager === true && isHospitalManager) ||
//                               (subMenuItem.isPatient === true && isPatient)
//                             ) &&
//                             (
//                               ((subMenuItem.isAdmin === true || subMenuItem.isSuperAdmin === true) &&
//                                 !(isAdmin || isSuperAdmin)) ||
//                               (subMenuItem.isPharmacist === true && !isPharmacist) ||
//                               (subMenuItem.isPathologist === true && !isPathologist) ||
//                               (subMenuItem.isNicuInCharge === true && !isNicuInCharge) ||
//                               (subMenuItem.isDoctor === true && !isDoctor) ||
//                               (subMenuItem.isHospitalManager === true && !isHospitalManager)
//                             )
//                           ) {
//                             return null;
//                           }

//                           return (
//                             <li
//                               key={`${section.sectionKey}-submenu-${menuIndex}-${subIndex}`}
//                               className="mt-1"
//                             >
//                               <NavLink
//                                 to={subMenuItem.link}
//                                 className={({ isActive }) =>
//                                   `text-sm hover:text-white transition duration-300 relative pl-7 w-full py-2 pr-2 rounded-md hover:bg-[rgba(255,255,255,0.16)] hover:before:bg-white before:w-2 before:h-2 before:absolute before:bg-M-text-color before:rounded-full before:left-3 before:top-1/2 before:-translate-y-1/2 before:transition before:duration-300 block ${
//                                     isActive
//                                       ? "bg-[rgba(255,255,255,0.16)] text-white before:bg-white"
//                                       : ""
//                                   }`
//                                 }
//                               >
//                                 {subMenuItem.name}
//                               </NavLink>
//                             </li>
//                           );
//                         })}
//                       </ul>
//                     </React.Fragment>
//                   );
//                 })}
//               </ul>
//             </div>
//           );
//         })}
//       </div>
//     </div>
//   );
// };

// export default Sidebar;

import React, { useState, useEffect } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { RiArrowRightSLine } from "react-icons/ri";
import logo from "../../../assets/logo/MH-icon.png";
import whiteLogo from "../../../assets/logo/logo-white.png";
import { sidebarSections } from "../../../utils/menuData";

const Sidebar = ({ 
  isSidebarOpen, 
  setIsSidebarOpen, 
  isAdmin, 
  isSuperAdmin, 
  isPathologist, 
  isPharmacist, 
  isNicuInCharge, 
  isDoctor, 
  isHospitalManager, 
  isPatient 
}) => {
  const [expandedMenu, setExpandedMenu] = useState({
    main: null,
    pharmacy: null,
    pathology: null,
    cms: null,
    settings: null,
    contact: null,
    others: null,
  });
  const location = useLocation();

  // Helper to find which menu should be open based on current URL
  const findActiveMenu = () => {
    let activeSectionKey = null;
    let activeMenuIndex = null;

    for (const section of sidebarSections) {
      for (let i = 0; i < section.menus.length; i++) {
        const menuItem = section.menus[i];

        if (menuItem.link === location.pathname) {
          activeSectionKey = section.sectionKey;
          activeMenuIndex = i;
          break;
        }

        if (menuItem.submenus) {
          for (const subMenuItem of menuItem.submenus) {
            if (subMenuItem.link === location.pathname) {
              activeSectionKey = section.sectionKey;
              activeMenuIndex = i;
              break;
            }
          }
        }
        if (activeSectionKey && activeMenuIndex !== null) break;
      }
      if (activeSectionKey && activeMenuIndex !== null) break;
    }
    return { activeSectionKey, activeMenuIndex };
  };

  useEffect(() => {
    const { activeSectionKey, activeMenuIndex } = findActiveMenu();
    if (activeSectionKey && activeMenuIndex !== null) {
      setExpandedMenu((prev) => ({
        ...prev,
        [activeSectionKey]: activeMenuIndex,
      }));
      setIsSidebarOpen(true);
    }
  }, [location.pathname, setIsSidebarOpen]);

  const toggleSubMenu = (index, sectionKey) => {
    setExpandedMenu((prev) => {
      const isAlreadyOpen = prev[sectionKey] === index;
      return {
        ...prev,
        [sectionKey]: isAlreadyOpen ? null : index,
      };
    });
  };

  const checkVisibility = (item) => {
    
    if (item.name === "Dashboard") return true; 

   if (item.isPatient === true) {
      if (isPatient) return true; 
    }
    if (item.name === "My Practice" && !isDoctor) return false;
    if (isPathologist && item.name === "All Reports") {
      return false;
    }

    if (isAdmin || isSuperAdmin) return true;
    if (isHospitalManager) {
      if (item.name === "Pathology Config" || item.name === "Pathology Accounts") {
        return false;
      }
    }

    // 4. SPECIFIC ROLE CHECKS:
    if (item.isPharmacist && isPharmacist) return true;
    if (item.isPathologist && isPathologist) return true;
    if (item.isNicuInCharge && isNicuInCharge) return true;
    if (item.isDoctor && isDoctor) return true;
    if (item.isHospitalManager && isHospitalManager) return true;

    return false;
  };

  return (
    <div
      className={`h-full bg-M-heading-color text-white min-h-screen transition-all duration-300 hover:w-72 group ${
        isSidebarOpen ? "w-72" : "w-16"
      }`}
    >
      {/* --- HEADER LOGO --- */}
      <div className="relative">
        <div
          className={`gap-2 py-[17px] border-b border-M-section-bg/10 flex ${
            isSidebarOpen
              ? "px-6"
              : "px-2 group-hover:px-6 justify-center group-hover:justify-between"
          }`}
        >
          <NavLink to="/" title="User Profile">
            <div className="flex items-center justify-between">
              <div className="group mx-auto w-full flex items-center gap-3">
                <img
                  src={whiteLogo}
                  alt="White Logo"
                  className={`duration-0 max-w-48 ${
                    isSidebarOpen ? "w-48" : "hidden group-hover:block w-48"
                  }`}
                />
                <img
                  src={logo}
                  alt="Logo"
                  className={`duration-0 rounded-full shrink-0 mx-auto ${
                    isSidebarOpen ? "hidden" : "w-9 group-hover:hidden"
                  }`}
                />
              </div>
            </div>
          </NavLink>
        </div>

        <span
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          className={`size-5 border-2 border-white rounded-full absolute right-3 top-1/2 -translate-y-1/2 hidden ${
            isSidebarOpen
              ? "lg:flex items-center justify-center"
              : "hidden group-hover:lg:flex"
          }`}
        >
          <span
            className={`size-2 bg-white rounded-full ${
              isSidebarOpen ? "block" : "hidden"
            }`}
          ></span>
        </span>
      </div>

      {/* --- MENU LIST --- */}
      <div
        className={`menu-bar hide-scrollbar ${
          isSidebarOpen ? "px-4" : "px-2 group-hover:px-4"
        } h-[calc(100vh-80px)] overflow-y-auto`}
      >
        {sidebarSections.map((section, sectionIndex) => {
          const visibleMenus = section.menus.filter((menuItem) => {
             const isParentVisible = checkVisibility(menuItem);
             if (!isParentVisible) return false;

             if (menuItem.isSubmenu) {
                const hasVisibleChild = menuItem.submenus?.some((sub) => checkVisibility(sub));
                return hasVisibleChild;
             }
             return true;
          });

          if (visibleMenus.length === 0) return null;

          return (
            <div key={sectionIndex}>
              <h4
                className={`pb-2 mt-4 border-b border-M-text-color/30 text-[#97aac1] font-semibold uppercase text-xs ml-2 tracking-wide ${
                  isSidebarOpen
                    ? ""
                    : "text-center hidden group-hover:block group-hover:text-left text-nowrap"
                }`}
              >
                {section.title}
              </h4>
              <ul className={`flex flex-col font-inter mt-1`}>
                {visibleMenus.map((menuItem, menuIndex) => {
                  
                  return (
                    <React.Fragment key={`${section.sectionKey}-${menuIndex}`}>
                      <li>
                        <div
                          className="mt-1"
                          onClick={() =>
                            menuItem.isSubmenu &&
                            toggleSubMenu(menuIndex, section.sectionKey)
                          }
                        >
                          {menuItem.isSubmenu ? (
                            <div
                              className={`flex items-center gap-2 cursor-pointer hover:bg-[rgba(255,255,255,0.16)] w-full py-2 px-2 rounded-md ${
                                isSidebarOpen
                                  ? "justify-between"
                                  : "justify-center group-hover:justify-between"
                              }`}
                            >
                              <span className="flex items-center gap-2 text-sm text-[#e2eeff]">
                                <menuItem.icon />
                                <span
                                  className={`${
                                    isSidebarOpen
                                      ? ""
                                      : "hidden group-hover:block text-nowrap"
                                  } `}
                                >
                                  {menuItem.name}
                                </span>
                              </span>

                              <RiArrowRightSLine
                                className={`transform transition-transform duration-300 ${
                                  expandedMenu[section.sectionKey] === menuIndex
                                    ? "rotate-90"
                                    : ""
                                } ${
                                  isSidebarOpen ? "" : "hidden group-hover:block"
                                }`}
                              />
                            </div>
                          ) : (
                            <div
                              className={`flex items-center gap-2 cursor-pointer ${
                                isSidebarOpen ? "justify-between" : "justify-center"
                              }`}
                            >
                              <NavLink
                                to={menuItem.link}
                                className={({ isActive }) =>
                                  `flex gap-2 items-center text-sm text-[#e2eeff] hover:bg-[rgba(255,255,255,0.16)] py-2 px-2 rounded-md ${
                                    isActive
                                      ? "bg-[rgba(255,255,255,0.16)] text-white"
                                      : ""
                                  } ${
                                    isSidebarOpen
                                      ? "w-full"
                                      : "w-auto group-hover:w-full"
                                  }`
                                }
                              >
                                <menuItem.icon />
                                <span
                                  className={`${
                                    isSidebarOpen
                                      ? ""
                                      : "hidden group-hover:block text-nowrap"
                                  } `}
                                >
                                  {menuItem.name}
                                </span>
                              </NavLink>
                            </div>
                          )}
                        </div>
                      </li>

                      {/* Submenu List */}
                      <ul
                        className={`transition-all duration-500 overflow-hidden text-sm text-gray-400 ${
                          expandedMenu[section.sectionKey] === menuIndex
                            ? "max-h-[500px] opacity-100"
                            : "max-h-0 opacity-0"
                        } ${isSidebarOpen ? "" : "hidden group-hover:block"}`}
                      >
                        {menuItem.submenus?.map((subMenuItem, subIndex) => {
                          
                          if (!checkVisibility(subMenuItem)) return null;

                          return (
                            <li
                              key={`${section.sectionKey}-submenu-${menuIndex}-${subIndex}`}
                              className="mt-1"
                            >
                              <NavLink
                                to={subMenuItem.link}
                                className={({ isActive }) =>
                                  `text-sm hover:text-white transition duration-300 relative pl-7 w-full py-2 pr-2 rounded-md hover:bg-[rgba(255,255,255,0.16)] hover:before:bg-white before:w-2 before:h-2 before:absolute before:bg-M-text-color before:rounded-full before:left-3 before:top-1/2 before:-translate-y-1/2 before:transition before:duration-300 block ${
                                    isActive
                                      ? "bg-[rgba(255,255,255,0.16)] text-white before:bg-white"
                                      : ""
                                  }`
                                }
                              >
                                {subMenuItem.name}
                              </NavLink>
                            </li>
                          );
                        })}
                      </ul>
                    </React.Fragment>
                  );
                })}
              </ul>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Sidebar;